import "./style.css";
import { Alert, Box, CircularProgress, createTheme, FormControl, InputLabel, Modal, Snackbar, ThemeProvider } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ErrorHandling } from "../../components/Errors/Errors";
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import { WhiteInput } from "../../components/Inputs/InputText";
import Lista from "../../components/Lista";
import { Popup } from "../../components/Popup/Popup";
import servOcupante from "../../services/login/servOcupante";
import servOcupanteDocs from "../../services/login/servOcupanteDocs";
import servParam from "../../services/login/servParam";
import { style as modalStyle } from "../../components/Loading/Loading";
import { OpcoesPeriodoDatas } from '../../components/Combobox/PeriodoDatas'
import { logout } from "../../state/slices/userSlice";
import Cadastro from "./Cadastro";
import { columnsOcupante } from "./Lista";
import ConsultarHomologacaoOcupante from "./ConsultarHomologacao";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OpcoesSituacaoOcupante } from "../../components/Combobox/SituacaoOcupante";
import { SearchFieldStyles } from "../../components/Searchfields/SearchFieldStyles";
import Select from 'react-select';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import ptBR from "date-fns/locale/pt-BR";
import { retornaDatasCfeTipoPeriodo } from "../../infra/utils/RetornaDatasCfeTipoPeriodo";
import { SearchFieldStylesFiltro } from "../../components/Searchfields/SearchFieldStylesFiltro";
import servFileIni from "../../services/login/servFileIni";
import { PopupExtraG } from "../../components/Popup/PopupExtraG";

const Ocupante = ({ onDblClick }) => {
    // Store e Navegação
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const tabs = useSelector(state => state.tabs);
    const navigate = useNavigate();

    const [filtro, setFiltro] = useState("");
    const [filtroCodigo, setFiltroCodigo] = useState("");
    const [situacaoOcupante, setSituacaoOcupante] = useState([]);
    const [ocupantes, setOcupantes] = useState([]);

    const [tipoPeriodo, setTipoPeriodo] = useState({ value: 8, label: 'Este mês' });
    const [tipoDataFiltro, setTipoDataFiltro] = useState("data-cadastro");
    const [dataInicialFiltro, setDataInicialFiltro] = useState(new Date());
    const [dataFinalFiltro, setDataFinalFiltro] = useState(new Date());
    
    const [openPopup, setOpenPopup] = useState(false);
    const [openConsultaHomolog, setOpenConsultaHomolog] = useState(false);
    const [recordForEdit, setRecordForEdit] = useState(null);

    // Carregamento e modais
    const [isLoading, setIsLoading] = useState(false);
    const [abrirMsgCancelamento, setAbrirMsgCancelamento] = useState(false);

    const [errorMessage, setErrorMessage] = useState("");
    const [openError, setOpenError] = useState(false);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [openHomologacao, setOpenHomologacao] = useState(false);
    const [openCancelamento, setOpenCancelamento] = useState(false);
    const [podeSolicitarHomologacao, setPodeSolicitarHomologacao] = useState(false);
    const [podeConsultarHomologacao, setPodeConsultarHomologacao] = useState(false);


    const theme = createTheme({
        components: {
            MuiIconButton: {
                styleOverrides: {
                    sizeMedium: {
                        color: "#d2d4d2"
                    }
                }
            }
        }
    });

    const handleCloseDialog = () => {
        setAbrirMsgCancelamento(false);
        setOpenPopup(false);
    }

    useEffect(() => {
        if (recordForEdit === null) {
            setPodeSolicitarHomologacao(false);
            return;
        }
        
        let situacao = recordForEdit?.Situacao || (recordForEdit?.row?.Situacao ?? 0);

        const podeSolicitarHomologacao = [0, 2];
        const podeConsultarHomologacao = [0];

        podeSolicitarHomologacao.includes(situacao) ? setPodeSolicitarHomologacao(true) : setPodeSolicitarHomologacao(false);
        podeConsultarHomologacao.includes(situacao) ? setPodeConsultarHomologacao(true) : setPodeConsultarHomologacao(false);
    }, [recordForEdit]);

    // Chamadas a API
    // Listar inicial
    useEffect(() => {
        const recuperarDados = async (filtroDatas) => {
            try {
                setIsLoading(true);

                let dados;
            
                // Se não tiver situação ou data informada, faz o listar básico, só com a pesquisa geral
                if(!filtroDatas) {
                    dados = await servOcupante.listarCFiltros(user.codigoUsuario, "");
                } else {
                    let arraySituacoes = [];

                    arraySituacoes = situacaoOcupante.map((item) => item.value);

                    dados = await servOcupante.listarCfeSituacaoOuData(user.codigoUsuario, 
                                                                            filtro, 
                                                                            filtroCodigo,
                                                                            arraySituacoes, 
                                                                            tipoDataFiltro,
                                                                            filtroDatas.dataInicial,
                                                                            filtroDatas.dataFinal);
                }

                let content = dados?.Content;

                if (dados.Content.length === 0) {
                    return setIsLoading(false);
                } 

                content && content.map((ocupante) => {
                    return ocupante.id = ocupante.Id
                });

                setOcupantes(content);

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);

                return ErrorHandling(
                    err?.response?.status, 
                    err?.Message, 
                    setOpenError, 
                    setErrorMessage, 
                    dispatch, 
                    logout, 
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        const recuperarUltimoTipoPeriodoDefinido = async () => {
            try {
                setIsLoading(true);

                let dto = {
                    CodigoUsuario: user.codigoUsuario.toString(),
                    CodigoSecao: "TIPO_PERIODO_P3",
                    Chave: "IDTIPOPERIODOOCUPANTE",
                    Conteudo: ""
                };

                let response = await servFileIni.Recuperar(dto);
                let novasDatas;

                if(response.Content.trim() !== "") {
                    let conteudo = Number(response.Content);
                    let labelTipoPeriodo = OpcoesPeriodoDatas.find((periodo) => periodo.value === conteudo).label;
                    
                    await setarTipoPeriodoERedefinirDatas({ value: conteudo, label: labelTipoPeriodo });
                    novasDatas = retornaDatasCfeTipoPeriodo(conteudo);
                } else {
                    await setarTipoPeriodoERedefinirDatas({ value: 8, label: "Este mês" });
                    novasDatas = retornaDatasCfeTipoPeriodo(8); // 8 - Este mês
                }

                if (ocupantes.length === 0) {
                    recuperarDados(novasDatas);
                }

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);

                return ErrorHandling(
                    err?.response?.status, 
                    err?.Message, 
                    setOpenError, 
                    setErrorMessage, 
                    dispatch, 
                    logout, 
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        recuperarUltimoTipoPeriodoDefinido();
    }, []);

    const onClickPesquisar = async () => {
        try {
            setIsLoading(true);
            let dados;

            if(situacaoOcupante.length === 0 &&
              (!dataInicialFiltro || dataInicialFiltro.toLocaleDateString() === "") && 
              (!dataFinalFiltro || dataFinalFiltro.toLocaleDateString() === "")) {
                dados = await servOcupante.listarCFiltros(user.codigoUsuario, filtro);
            } else {
                let arraySituacoes = [];

                arraySituacoes = situacaoOcupante.map((item) => item.value);

                dados = await servOcupante.listarCfeSituacaoOuData(user.codigoUsuario, 
                                                                            filtro, 
                                                                            filtroCodigo,
                                                                            arraySituacoes, 
                                                                            tipoDataFiltro, 
                                                                            dataInicialFiltro, 
                                                                            dataFinalFiltro);
            }

            let content = dados?.Content;

            content && content.map((ocupante) => {
                return ocupante.id = ocupante.Id            
            });

            setIsLoading(false);

            setRecordForEdit(null);

            setOcupantes(content);

            if (content.length === 0) {
                setErrorMessage("Não foram encontrados registros para sua pesquisa");
                setOpenError(true);
            }
        } catch (err) {
            setIsLoading(false);

            return ErrorHandling(
                err?.response?.status, 
                err?.Message, 
                setOpenError, 
                setErrorMessage, 
                dispatch, 
                logout, 
                navigate,
                err?.response?.data?.Message);
        }
    }

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

     const adicionarOuEditar = async (ocupante) => {
            let id; 
        if (ocupante.Id == 0) {
            const response = await servOcupante.inserir(
                ocupante.codigoResponsavel,
                ocupante.nome, 
                ocupante.inscricao, 
                ocupante.codigoCidade, 
                ocupante.uf, 
                ocupante.endereco, 
                ocupante.numero,
                ocupante.bairro,
                ocupante.cep,
                ocupante.nomeRepresentante,
                ocupante.cpfRepresentante,
                ocupante.numeroTermoAutorizacao,
                ocupante.dataAto,
                ocupante.processoAnatel,
                ocupante.numeroContrato,
                ocupante.situacao,
                ocupante.cadastradoPorAnalista
            );

            id = response.Content.Id;
        } else {
            const response = await servOcupante.editar(
                ocupante.Id,
                ocupante.codigoResponsavel,
                ocupante.nome, 
                ocupante.inscricao, 
                ocupante.codigoCidade, 
                ocupante.uf, 
                ocupante.endereco, 
                ocupante.numero,
                ocupante.bairro,
                ocupante.cep,
                ocupante.nomeRepresentante,
                ocupante.cpfRepresentante,
                ocupante.numeroTermoAutorizacao,
                ocupante.dataAto,
                ocupante.processoAnatel,
                ocupante.numeroContrato,
                ocupante.situacao,
                ocupante.cadastradoPorAnalista
            )

            id = response.Content.Id;
        }
    
        setRecordForEdit(null);

        return id;
    }

    const cancelarOcupante = async () => {
        try {
            setIsLoading(true);

            await servOcupante.Cancelar(recordForEdit?.row?.Id || recordForEdit?.Id );
        
            // setSuccessMessage("Ocupante cancelado com sucesso.");
            setIsLoading(false);
            setAbrirMsgCancelamento(false);

            setTimeout(() => {
                setOpenPopup(false);
                onClickPesquisar();
            }, [1400]);

        } catch (err) {
            setIsLoading(false);
            setAbrirMsgCancelamento(false);
            setErrorMessage(err?.response?.data?.Message);
            return;
        }
    }

    const solicitarHomologacaoOcupante = async () => {
        try {
            setIsLoading(true);

            await servOcupante.SolicitarHomologacao(recordForEdit?.row?.Id || recordForEdit?.Id );
            
            // setSuccessMessage("Solicitação de homologação enviada com sucesso.");
            setIsLoading(false);

            setTimeout(() => {
                setOpenPopup(false);
                onClickPesquisar();
            }, [1400]);

        } catch (err) {
            setIsLoading(false);
            setErrorMessage(err?.response?.data?.Message);
            return;
        }
    }

    const solicitarHomologacao = async () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenErrorWindow(true);
        }

        const situacoesHomologaveis = [0, 2];

        if (!situacoesHomologaveis.includes(recordForEdit?.row?.Situacao) && !situacoesHomologaveis.includes(recordForEdit?.Situacao)) {
            setErrorMessage("Só é possível homologar ocupantes com situação em digitação ou revisão")
            return setOpenErrorWindow(true);
        }

        try {
            setIsLoading(true);

            const idOcupante = recordForEdit?.row?.Id || recordForEdit?.Id;

            const [docsObrigatorios, docsVinculados] = await Promise.all([
                servParam.RecuperarDocumentosObrigatorios(11),
                servOcupanteDocs.listar(idOcupante)
            ]);

            const docsAtualizados = docsObrigatorios.Content.map((doc) => {
                const documentoVinculado = docsVinculados.Content?.find(
                    (docVinculado) =>
                        doc.Id == docVinculado.CodigoConfiguracaoDoc &&
                        doc.CodigoClassificacaoDoc == docVinculado.CodigoClassificacaoDoc
                );

                if (documentoVinculado) {
                    return {
                        ...doc,
                        CodigoDocumento: documentoVinculado.CodigoDocs
                    };
                }

                return doc;
            });

            const docsObrigatoriosPendentes = docsAtualizados.filter(
                doc => doc.Obrigatorio === 1 && !doc.CodigoDocumento
            );

            setIsLoading(false);

            if (docsObrigatoriosPendentes.length > 0) {
                const nomesDocs = docsObrigatoriosPendentes.map(doc => doc.Descricao).join(', ');
                setErrorMessage(`Existem documentos obrigatórios pendentes: ${nomesDocs}`);
                return setOpenErrorWindow(true);
            }

            return solicitarHomologacaoOcupante();
        } catch (err) {
            setIsLoading(false);
            setErrorMessage(err?.response?.data?.Message || "Erro ao verificar documentos obrigatórios.");
            return setOpenErrorWindow(true);
        }
    }

    const solicitarCancelamento = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenErrorWindow(true);
        }

        const situacoesCancelaveis = [0, 1, 2];

        if (situacoesCancelaveis.includes(recordForEdit?.row?.Situacao) || situacoesCancelaveis.includes(recordForEdit?.Situacao)) {
            if(user.codigoUsuario !== (recordForEdit?.row?.CodigoResponsavelTecnico || recordForEdit?.CodigoResponsavelTecnico)) {
                setErrorMessage("Não é possível cancelar, este ocupante foi criado por outro responsável técnico");
                return setOpenErrorWindow(true);
            }

            return setAbrirMsgCancelamento(true);
        }
        setErrorMessage("Só é possível cancelar ocupantes com situação em digitação, pendente de homologação ou revisão");
        return setOpenErrorWindow(true);
    }

    const handleTipoDataFiltro = (event) => {
        event.preventDefault();

        setTipoDataFiltro(event.target.value)
    }

    const setarTipoPeriodoERedefinirDatas = async (tipoPeriodo) => {
        try {
            setTipoPeriodo(tipoPeriodo);

            let datasCalculadas = retornaDatasCfeTipoPeriodo(tipoPeriodo?.value);
            setDataInicialFiltro(datasCalculadas.dataInicial);
            setDataFinalFiltro(datasCalculadas.dataFinal);

            let dto = {
                Chave: "IDTIPOPERIODOOCUPANTE",
                Conteudo: tipoPeriodo.value.toString(),
                CodigoSecao: "TIPO_PERIODO_P3",
                CodigoUsuario: user.codigoUsuario.toString()
            };

            await servFileIni.Inserir(dto);
        } catch (err) {
            setIsLoading(false);
            setErrorMessage("Erro ao salvar tipo de período. Tente novamente.");
            setOpenError(true);
            return;
        }
    }

     const consultarHomologacao = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenErrorWindow(true);
        }
    
        return setOpenConsultaHomolog(true);
    }

    const adicionarNovoOcupante = () => {
        setRecordForEdit(null);
        setOpenPopup(true);
    }

    return (
        <div className="ocupante-container">
            <div className="ocupanteFiltros">
                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8", marginLeft: "10px" }} >Pesquisa geral<FontAwesomeIcon style={{ marginLeft: "10px", width: "15px", height: "15px", cursor: "pointer"}} icon={faQuestionCircle} /></InputLabel>
                    <WhiteInput value={filtro} onChange={(e) => setFiltro(e.target.value)} placeholder="Pesquisa" id="pesquisa-nome" sx={{ width: "500px", margin: '0px 18px' }} />
                </FormControl>
            </div>
            <div className="ocupanteFiltros" style={{ marginTop: "20px"}}>
                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8", marginLeft: "10px" }} >Ocupante</InputLabel>
                    <WhiteInput value={filtroCodigo} onChange={(e) => setFiltroCodigo(e.target.value)} placeholder="Ocupante" id="pesquisa-codigo" sx={{ width: "200px", margin: '0px 18px' }} />
                </FormControl>
                <FormControl variant="outlined" sx={{ width: "450px", marginRight: "20px" }}>
                    <InputLabel htmlFor="pesquisa-nome-situacao" shrink style={{ color: "#B8B8B8" }}>
                        Situação
                    </InputLabel>
                    <Select     
                        isMulti={true}
                        value={situacaoOcupante}
                        onChange={value => setSituacaoOcupante(value)}
                        options={OpcoesSituacaoOcupante}
                        styles={SearchFieldStyles}
                        placeholder="Situação"
                    />
                </FormControl>
            </div>
            <div className="ocupanteFiltros">
                <FormControl variant="outlined">
                    <InputLabel htmlFor="data-ocupante" shrink style={{ color: "#B8B8B8", marginTop: "20px", marginLeft: "10px" }} >
                        <select className="tipoDataFiltroConsulta" name="tipo-data" id="tipo-data" value={tipoDataFiltro} onChange={handleTipoDataFiltro}>
                            <optgroup>
                                <option value="data-cadastro" selected>Data cadastro</option>
                                <option value="data-envio-homolog">Data envio homolog.</option>
                            </optgroup>
                        </select>
                    </InputLabel>
                    <div className="ocupanteDatas">
                        <Select
                            value={tipoPeriodo}
                            onChange={(e) => setarTipoPeriodoERedefinirDatas(e)}
                            options={OpcoesPeriodoDatas}
                            styles={SearchFieldStylesFiltro}
                            placeholder="Período"
                        />
                        <ThemeProvider theme={theme}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                                <DatePicker 
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataInicialFiltro}
                                    onChange={(e) => setDataInicialFiltro(e)}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#707070" }} />
                                            <span style={{ position: "absolute", top: 58, right: 250, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                    componentsProps={{
                                        actionBar: {
                                            actions: ["today"]
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                        <span style={{ color: "whitesmoke", margin: "9px 5px" }}>-</span>
                        <ThemeProvider theme={theme}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                                <DatePicker 
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataFinalFiltro}
                                    onChange={(e) => setDataFinalFiltro(e)}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#707070" }} />
                                            <span style={{ position: "absolute", top: 58, right: 30, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                    componentsProps={{
                                        actionBar: {
                                            actions: ["today"]
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                    </div>
                </FormControl>
                <BlueHoverButton variant="contained" onClick={onClickPesquisar} style={{ marginTop: "16.5px" }}>
                    Pesquisar
                </BlueHoverButton>
            </div>
            <div className="ocupante-botoes">
                <BlueHoverButton variant="contained" onClick={adicionarNovoOcupante}>Novo ocupante</BlueHoverButton>
                {!podeConsultarHomologacao && <BlueHoverButton variant="contained" onClick={consultarHomologacao}>Consultar homologação</BlueHoverButton>}
                {podeSolicitarHomologacao && <BlueHoverButton variant="contained" onClick={solicitarHomologacao}>Solicitar homologação</BlueHoverButton>}
                <BlueHoverButton variant="contained" onClick={solicitarCancelamento}>Cancelar</BlueHoverButton>
            </div>
            <div className="ocupante-lista" style={ { height: '430px' } }>
                <Modal open={isLoading}>
                    <Box style={modalStyle}>
                        <CircularProgress color="inherit" />
                    </Box>
                </Modal>
                <Lista 
                    columns={columnsOcupante}
                    rows={ocupantes}
                    onDblClick={onDblClick ? onDblClick : setOpenPopup}
                    setSelectedData={setRecordForEdit}
                    hideFooter={false}
                    autoHeight={false}
                />
                <PopupExtraG title="Ocupante" openPopup={openPopup} setOpenPopup={setOpenPopup}>
                    <Cadastro 
                        setOpenPopup={setOpenPopup} 
                        recordForEdit={recordForEdit}
                        addOrEdit={adicionarOuEditar}   
                        pesquisar={onClickPesquisar} 
                        origemSolicitacao={false}
                    />
                </PopupExtraG>
                <Popup title="Homologação" openPopup={openConsultaHomolog} setOpenPopup={setOpenConsultaHomolog} minHeight="100px">
                    <ConsultarHomologacaoOcupante
                        setOpenPopup={setOpenConsultaHomolog}
                        recordForEdit={recordForEdit}
                        pesquisar={onClickPesquisar}
                    />
                </Popup>
                    <Dialog
                        open={abrirMsgCancelamento}
                        onClose={handleCloseDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        sx={{
                            '& .MuiPaper-root': {
                                backgroundColor: "#232323",
                                color: "whitesmoke",
                                padding: "20px",
                                borderRadius: "10px"
                            }
                        }}
                    >
                    <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold" }}>
                        {"Cancelar ocupante"}
                    </DialogTitle>
                    <DialogContent>        
                        <Typography variant="body1" sx={{ color: 'whitesmoke' }}>
                            Tem certeza que deseja cancelar o ocupante selecionado?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <BlueHoverButton 
                            autoFocus 
                            onClick={cancelarOcupante}
                        >
                            Continuar
                        </BlueHoverButton>
                        <BlueHoverButton 
                        onClick={handleCloseDialog}>Cancelar</BlueHoverButton>
                    </DialogActions>
                </Dialog>
                <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}> 
                    <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
                </Snackbar>
            </div>
        </div>
    )
}

export { Ocupante };